import { useEffect, useState } from 'react';
import { Container, Typography, Box, TextField, MenuItem, Button, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { getTripsSummary, exportTripsFile } from '../api/reportsApi';

export default function TripReports() {
  const [groupBy, setGroupBy] = useState<'company'|'driver'>('company');
  const [start, setStart] = useState<string>('');
  const [end, setEnd] = useState<string>('');
  const [rows, setRows] = useState<any[]>([]);
  const [error, setError] = useState<string | null>(null);

  const load = async () => {
    try {
      const res = await getTripsSummary({ group_by: groupBy, start: start || undefined, end: end || undefined } as any);
      setRows(res.rows || []);
      setError(null);
    } catch (e: any) {
      setError(e?.message || 'Erreur lors du chargement des rapports');
      setRows([]);
    }
  };

  useEffect(() => { load(); }, []);

  const exportFile = async (file: 'csv'|'xlsx'|'pdf') => {
    try {
      await exportTripsFile({ group_by: groupBy, start: start || undefined, end: end || undefined, format: 'summary' } as any, file);
    } catch (e: any) {
      setError(e?.message || 'Erreur export');
    }
  };

  return (
    <Container maxWidth="xl" sx={{ py: 2 }}>
      <Typography variant="h4" gutterBottom>Rapports — Courses</Typography>
      <Box mb={2} display="grid" gridTemplateColumns={{ xs: '1fr', md: 'repeat(5, 1fr)' }} gap={2}>
        <TextField select label="Grouper par" value={groupBy} onChange={(e) => setGroupBy(e.target.value as any)}>
          <MenuItem value="company">Compagnie</MenuItem>
          <MenuItem value="driver">Chauffeur</MenuItem>
        </TextField>
        <TextField type="date" label="Début" InputLabelProps={{ shrink: true }} value={start} onChange={(e) => setStart(e.target.value)} />
        <TextField type="date" label="Fin" InputLabelProps={{ shrink: true }} value={end} onChange={(e) => setEnd(e.target.value)} />
        <Button variant="contained" onClick={load}>Filtrer</Button>
        <Button variant="outlined" onClick={() => exportFile('csv')}>Export CSV</Button>
        <Button variant="outlined" onClick={() => exportFile('xlsx')}>Export Excel</Button>
        <Button variant="outlined" onClick={() => exportFile('pdf')}>Export PDF</Button>
      </Box>

      {error && <Typography color="error" sx={{ mb: 2 }}>{error}</Typography>}

      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{groupBy === 'company' ? 'Compagnie' : 'Chauffeur'}</TableCell>
            <TableCell align="right">Poids total (T)</TableCell>
            <TableCell align="right">Montant total</TableCell>
            <TableCell align="right">Nb courses</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((r) => (
            <TableRow key={r.groupId}>
              <TableCell>{r.groupName}</TableCell>
              <TableCell align="right">{r.totalWeightT}</TableCell>
              <TableCell align="right">{r.totalAmount}</TableCell>
              <TableCell align="right">{r.tripsCount}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Container>
  );
}
